import { render, staticRenderFns } from "./AppTopbar.vue?vue&type=template&id=451e04ac&"
import script from "./AppTopbar.vue?vue&type=script&lang=js&"
export * from "./AppTopbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports